import { useStyles } from '../styles';
import Button from '@material-ui/core/Button';
import ChannelsFormDetails from './shared/ChannelsFormDetails';
import ChannelsUserDetails from './shared/ChannelsUserDetails';
import Paper from '@material-ui/core/Paper';
import React, { useEffect, useState } from 'react';
import Review from './ChannelReview';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import Typography from '@material-ui/core/Typography';
import useCustomUserSelected from '../../../Hooks/useCustomUserSelected';
const steps = ['Overview', 'Users', 'Review'];

export const UserSelectionChannelCreateContext = React.createContext({});
export default function Form(props: any) {
    const {
        clearExtractedUsers,
        clearForm,
        createChannel,
        distinctUsers,
        fetchUsersFromGroup,
        makeDistinctUsersFromCombined,
        setToastError,
        users, //Searchable users and groups
        users_loading,
    } = props;

    //Feeds in Searchable users and groups and no initially selected rows
    const userSelectionHook = useCustomUserSelected([], []);

    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const [privateMode, setPrivateMode] = useState(false);

    const [nameField, setNameField] = useState('');
    const [isNameHidden, setIsNameHidden] = useState(false);
    const [imageURL, setImageURL] = useState('');
    const [fileSelected, setFileSelected] = useState(false);
    const [nameEmpty, setNameEmpty] = useState(false);
    // eslint-disable-next-line
    const [combinedUsers, setCombinedUsers] = useState(Array());
    //On component mount, we create a "clone" of users
    useEffect(() => {
        userSelectionHook.setUsers(
            users.map((user: any) => {
                return { id: user.id, name: user.name, type: user.type };
            }),
        );
    }, []);

    const handleNameChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = evt.target;
        setNameField(value);
    };

    const handleIsNameHiddenChange = (evt: any) => {
        const { checked } = evt.target
        setIsNameHidden(checked);
    };

    const handleFileChange = async (res: any) => {
        setImageURL(res);
        setFileSelected(true); //Used in the saga to determine whether to sync filestorage or not
    };

    interface IWhitelist {
        [key: string]: any;
    }

    useEffect(() => {
        return () => {
            clearForm();
        };
    }, [clearForm]);

    const handleNext = async () => {
        if (nameField === '') {
            setNameEmpty(true);
            return false;
        }
        if (activeStep === 1) {
            //prior to displaying review

            if (privateMode && userSelectionHook.checked.length === 0) {
                setToastError('When creating a private channel, you must add users');
                return false;
            }
            makeDistinctUsersFromCombined(userSelectionHook.checked);
        }

        if (activeStep === 2) {
            //After clicking "Next" from review page

            createChannel({
                fileSelected,
                imageURL,
                name: nameField,
                isNameHidden,
                whitelist: distinctUsers,
            });
        } else {
            setActiveStep(activeStep + 1);
        }
    };

    const handleBack = () => {
        setCombinedUsers([]);
        clearExtractedUsers();
        setActiveStep(activeStep - 1);
    };

    return (
        <React.Fragment>
            <Paper className={classes.paper}>
                <Typography align="center" component="h1" variant="h4">
                    Create a Channel
                </Typography>
                <Stepper activeStep={activeStep} className={classes.stepper}>
                    {steps.map(label => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>

                <React.Fragment>
                    {activeStep === 0 && (
                        <ChannelsFormDetails
                            handleFileChange={handleFileChange}
                            handleNameChange={handleNameChange}
                            imageURL={imageURL}
                            nameEmpty={nameEmpty}
                            nameField={nameField}
                            isNameHidden={isNameHidden}
                            handleIsNameHiddenChange={handleIsNameHiddenChange}
                        />
                    )}

                    {activeStep === 1 && (
                        <ChannelsUserDetails
                            privateMode={privateMode}
                            setPrivateMode={setPrivateMode}
                            userSelectionHook={userSelectionHook}
                        />
                    )}
                    {activeStep === 2 && (
                        <Review
                            distinctUsers={distinctUsers}
                            fetchUsersFromGroup={fetchUsersFromGroup}
                            imageURL={imageURL}
                            name={nameField}
                            users_loading={users_loading}
                        />
                    )}

                    <div className={classes.buttons}>
                        {activeStep !== 0 && (
                            <Button className={classes.button} onClick={handleBack}>
                                Back
                            </Button>
                        )}
                        <Button className={classes.button} color="primary" onClick={handleNext} variant="contained">
                            {activeStep === steps.length - 1 ? 'Create' : 'Next'}
                        </Button>
                    </div>
                </React.Fragment>
            </Paper>
        </React.Fragment>
    );
}
